export default __webpack_public_path__ + "static/media/alert.16ae4a6c.svg";